"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gmailFindEmail = exports.gmailFindEmailResultSchema = exports.gmailFindEmailArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.gmailFindEmailArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('find-email', zod_1.z.object({
    q: zod_1.z.string().describe('Gmail search query'),
    withTextPayload: zod_1.z
        .boolean()
        .nullish()
        .describe('Convert the payload response into a single text field for easier LLM processing'),
    labels: zod_1.z
        .array(zod_1.z.string())
        .nullish()
        .describe('Only return messages with all specified labels'),
    includeSpamTrash: zod_1.z
        .boolean()
        .nullish()
        .describe('Include messages from SPAM and TRASH folders'),
    maxResults: zod_1.z.number().nullish().describe('Maximum number of messages to return'),
}));
var gmailFindEmailMessageSchema = zod_1.z.object({
    id: zod_1.z.string().describe('The immutable ID of this message'),
    threadId: zod_1.z.string().describe('The ID of the thread the message belongs to'),
    labelIds: zod_1.z.array(zod_1.z.string()).describe('List of label IDs applied to this message'),
    snippet: zod_1.z.string().nullish().describe('A short part of the message text'),
});
exports.gmailFindEmailResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.array(gmailFindEmailMessageSchema));
exports.gmailFindEmail = (0, common_1.createToolMetadata)({
    id: 'gmailFindEmail',
    displayName: 'Gmail Find Email',
    displayDescription: 'Search for messages using Gmail search syntax',
    category: 'communication',
    color: common_1.BRAND_COLORS.GMAIL,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GMAIL),
    icon: 'gmail',
    argsSchema: exports.gmailFindEmailArgsSchema,
}, exports.gmailFindEmailResultSchema);
